import * as React from 'react';
import { Link, Redirect,RouteComponentProps, } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { Form, Icon, Spin, Input, Button, notification, Row, Col } from 'antd';
import {renderLogin} from '../../Navigation/RenderLogin'
/** Presentational */
import FormWrapper from '../../Components/Styled/FormWrapper';
/** App theme */
import { colors } from '../../Themes/Colors';
var qs = require('qs');

interface Props extends RouteComponentProps{
  form: any;
};

type State = {
  username: string;
  redirect: boolean;
  loading: boolean;
};

class ForgotPasswordContainer extends React.Component<Props, State> {
  state = {
    username: '',
    redirect: false,
    loading: false
  };

  handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    this.props.form.validateFields((err: { message: string }, values: { username: string }) => {
      if (!err) {
        let { username } = values;
        username = username.trim();
        
        this.setState({
          loading: true,
          username
        });

        Auth.forgotPassword(username)
          .then(data => {
            notification.success({
              message: 'Redirecting you in a few!',
              description: 'Account confirmed successfully!',
              placement: 'topRight',
              duration: 1.5,
              onClose: () => {
                this.setState({ redirect: true });
              }
            });
          })
          .catch(err => {
            notification.error({
              message: 'User confirmation failed',
              description: err.message,
              placement: 'topRight',
              duration: 1.5
            });
            this.setState({ loading: false });
          });
      }
    });
  };

  render() {
    console.log("Props:", this.props.location.search);
    const { getFieldDecorator } = this.props.form;
    const { loading, redirect, username } = this.state;
    let context = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).context;
    context = context?"&context="+context+"="+context:"";
    return (
      <React.Fragment>
        <FormWrapper onSubmit={this.handleSubmit} className="login-form">
          <Form.Item>
            {getFieldDecorator('username', {
              rules: [
                {
                  required: true,
                  message: 'Please input your username!'
                }
              ]
            })(
              <Input prefix={<Icon type="user" style={{ color: colors.transparentBlack }} />} placeholder="Username" />
            )}
          </Form.Item>
          <Form.Item className="text-center">
            <Row>
              <Col lg={24}>
                <Button style={{ width: '100%' }} type="primary" htmlType="submit" className="login-form-button">
                  {loading ? (
                    <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />
                  ) : (
                    'Confirm username'
                  )}
                </Button>
              </Col>
              <Col lg={24}>
                {renderLogin(context,"Ooh! Wait! I've remembered!")}
              </Col>
            </Row>
          </Form.Item>
        </FormWrapper>
        {redirect && (
          <Redirect
            to={{
              pathname: '/reset-password',
              search: `?username=${username}${context}`
            }}
          />
        )}
      </React.Fragment>
    );
    //<Button style={{borderStyle:"none",margin:'0px',padding:'0px', color:'#1890ff'}} onClick={()=>{this.props.history.goBack()}}>Ooh! Wait! I've remembered!</Button>
    //<Button style={{borderStyle:"none",margin:'0px',padding:'0px', color:'#1890ff'}} onClick={"MyInterface.closeActivity()"}>Ooh! Wait! I've remembered!</Button>
    //<Button style={{borderStyle:"none",margin:'0px',padding:'0px', color:'#1890ff'}} onClick={()=>{android.closeActivity()}}>Ooh! Wait! I've remembered!</Button>

    //<Link to="/login">Ooh! Wait! I've remembered!</Link>
  }
}

export default Form.create()(ForgotPasswordContainer);
